<template>
  <div :class="{'is-size-8': !showTypePiece, 'width-100percent': showTypePiece}">
    <table :class="{'width-100percent': showTypePiece}">
      <tr>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.type')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.code')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.etat')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.date')}}
        </th>
        <th class="has-text-left" v-if="showTypePiece">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.typeDePiece')}}
        </th>
        <th class="has-text-left">
          {{$t('detailContrat.echeancier.tabEcheance.tooltip.regle')}}
        </th>
      </tr>
      <tr v-for="(facture, index) in getPaiements(commande)" :key="index">
        <td class="has-text-left">
          {{getSousTypeLibelle(facture.sousType)}}
        </td>
        <td class="has-text-left">
          {{facture.code}}
        </td>
        <td class="has-text-left">
          {{getEtatLibelle(facture.etat)}}
        </td>
        <td class="has-text-right">
          {{facture.datePremierPaiement| formatDate }}
        </td>
        <td class="has-text-left" v-if="showTypePiece">
          {{getTypePieceLibelle(facture.typeDePiece)}}
        </td>
        <td class="has-text-right">
          <router-link-blank
            v-if="showTypePiece && facture.typeDePiece"
            :to="{ name: getRouteName(facture),
                  params: { id: facture.paiementId } }"
            :message="getMontant(facture.montantReglee)">
          </router-link-blank>
          <span v-else>
            {{getMontant(facture.montantReglee)}}
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>

import { TYPE_OD } from '@/configuration/compta/ecritureConf';
import {
  FACTURE_SOUS_TYPE, FACTURE_ETAT,
  SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE,
} from '@/configuration/facture/factureConf';
import cloneDeep from 'lodash/cloneDeep';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { CHARGE } from '@/configuration/mouvementClient/mouvementClientConf';

export default {
  name: 'echeancePaiementsTable',
  props: {
    commande: {
      type: Object,
      required: true,
    },
    showTypePiece: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    routerLinkBlank,
  },
  data() {
    return {
      func: {
        formatDevise,
      },
    };
  },
  computed: {

  },
  methods: {
    getSousTypeLibelle(type) {
      return this.$t(FACTURE_SOUS_TYPE.find(st => st.code === type).libelle);
    },
    getEtatLibelle(etat) {
      return this.$t(FACTURE_ETAT.find(st => st.code === etat).libelle);
    },
    getPaiements(ligne) {
      const paiements = [];
      if (!ligne.factures || ligne.factures.length === 0) {
        return paiements;
      }
      ligne.factures.forEach(facture => {
        if (facture.lettrages.length === 0 || facture.aRapprocher) {
          paiements.push(facture);
        } else {
          facture.lettrages.forEach(lettrage => {
            const paiement = cloneDeep(facture);
            paiement.datePremierPaiement = lettrage.dateLettrage;
            if ([SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE].includes(facture.sousType)) {
              paiement.montantReglee = lettrage.montant * -1;
            } else {
              paiement.montantReglee = lettrage.montant;
            }
            if (this.showTypePiece) {
              const paiementItem = paiement.listePaiement
                ?.find(l => l.lettrageId === lettrage.id);
              paiement.typeDePiece = paiementItem?.typeDePiece;
              paiement.paiementId = paiementItem?.id;
            }
            paiements.push(cloneDeep(paiement));
          });
        }
      });
      return paiements;
    },
    getRouteName(facture) {
      if (facture.typeDePiece === TYPE_OD) {
        return 'c.comptabilite.operation_diverse';
      }
      if (facture.typeDePiece === CHARGE) {
        return 'c.baux.facture_achat';
      }
      return 'c.baux.lot_paiement';
    },
    getMontant(montant) {
      return this.func.formatDevise(montant);
    },
    getTypePieceLibelle(typePiece) {
      if (typePiece === undefined) {
        return '';
      }
      return this.$t(`detailContrat.echeancier.tabEcheance.tooltip.${typePiece}`);
    },
  },
};
</script>
